import type { App } from 'vue';

import { ENV } from '@/env';
import { loggerKey } from '@/infra/injection-keys';

export { loggerKey };

export interface LoggerType {
  d: (...args: any[]) => void;
  i: (...args: any[]) => void;
  w: (...args: any[]) => void;
  e: (...args: any[]) => void;
}

/* eslint-disable no-console */
if (!ENV.DEBUG) {
  console.debug = () => {};
  console.info = () => {};
  console.warn = () => {};
  console.error = () => {};
}

const logger: LoggerType = {
  d: console.debug.bind(console),
  i: console.info.bind(console),
  w: console.warn.bind(console),
  e: console.error.bind(console),
};

export const loggerPlugin = {
  install(app: App) {
    app.provide(loggerKey, logger);
  },
};
